import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { NgFor, AsyncPipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Observable, startWith, map } from 'rxjs';

export interface multiselectItem{
  label: string;
  value: any;
}
@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatChipsModule,
    NgFor,
    MatIconModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
})
export class MultiselectComponent {
  @Input() label: string = "Select an Element";  
  @Input() placeholder: string = "Search an element";
  @Input() selectedItems: multiselectItem[] = [];
  @Input() AllItems: multiselectItem[] = [];
  @Input() AddNewItemEnabled: boolean = true;
  @Output() onChange: any = new EventEmitter<multiselectItem[]>();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  itemCtrl = new FormControl('');
  filteredItems: Observable<multiselectItem[]>;
  tempFilteredItems: multiselectItem[] = [];

  @ViewChild('itemInput') itemInput: ElementRef<HTMLInputElement>;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.AllItems) {
      this.filteredItems = this.itemCtrl.valueChanges.pipe(
        startWith(''),
        map((item: string) => item ? this._filter(item) : this.AllItems?.slice()),
      );
    }
  }

  add(event: MatChipInputEvent): void {
    if(!this.AddNewItemEnabled) {
      return;
    }
    const value = (event.value || '').trim();

    // Add our tag
    if (value) {
      this.selectedItems.push({ label: value, value: value });
    }

    // Clear the input value
    event.chipInput!.clear();

    this.itemCtrl.setValue(null);
  }

  remove(item: multiselectItem): void {
    const index = this.selectedItems.indexOf(item);

    if (index >= 0) {
      this.selectedItems.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.selectedItems.find(item => item.value === event.option.viewValue)) {
      this.selectedItems.push({ label: event.option.viewValue, value: event.option.viewValue });
    }
    this.itemInput.nativeElement.value = '';
    this.itemCtrl.setValue(null);
    this.onChange.emit(this.selectedItems);
  }
  private filterItems(value: string): void {
    this.tempFilteredItems = this.tempFilteredItems.filter(item => item.label.toLowerCase().includes(value.toLowerCase()));
  } 

  private _filter(value: any): multiselectItem[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value.label.toLowerCase();

    return this.AllItems.filter(tag => tag.label.toLowerCase().includes(filterValue));
  }
}
